var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.286 0A4.286 4.286 0 000 4.286v.857h24v-.857A4.286 4.286 0 0019.714 0H4.286zM24 6.857H0v12.857A4.286 4.286 0 004.286 24h15.428A4.286 4.286 0 0024 19.714V6.857zM8.571 12a1.714 1.714 0 11-3.428 0 1.714 1.714 0 013.428 0zm-1.714 6.857a1.714 1.714 0 110-3.428 1.714 1.714 0 010 3.428zM13.714 12a1.714 1.714 0 11-3.428 0 1.714 1.714 0 013.428 0zM12 18.857a1.714 1.714 0 110-3.428 1.714 1.714 0 010 3.428zM18.857 12a1.714 1.714 0 11-3.428 0 1.714 1.714 0 013.428 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "70e07443fb0fa0c4af7c36b77f925a9d.svg";
export { MemoForwardRef as ReactComponent };